import { render, staticRenderFns } from "./InstitutionalInformation.vue?vue&type=template&id=a994e4f8"
import script from "./InstitutionalInformation.vue?vue&type=script&lang=js"
export * from "./InstitutionalInformation.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalInformation.vue?vue&type=style&index=0&id=a994e4f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports